import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { RightSidebarContent } from './RightSidebarContent'
import './RightSidebar.scss'

export interface RightSidebarProps {
  isOpen: boolean
  onToggle: () => void
  /** Pfad des aktiven Tabs — immer eine „Ziele"-Seite, `MainLayout` rendert
   *  das Panel nur dort. Liefert den Lebensbereich für das Hilfe-Panel. */
  activeTabPath?: string
}

const RightSidebarComponent: React.FC<RightSidebarProps> = ({
  isOpen,
  // onToggle is part of the API (the titlebar button toggles the panel) but the
  // panel no longer reacts to it itself.
  activeTabPath,
}) => {
  const { t } = useTranslation()

  // Memoize CSS class
  const sidebarClassName = useMemo(
    () => `right-sidebar ${isOpen ? 'right-sidebar--open' : ''}`,
    [isOpen]
  )

  return (
    <div className={sidebarClassName}>
      <div className="right-sidebar__header">
        <h3 className="right-sidebar__title">{t('goals.help.title')}</h3>
      </div>

      <div className="right-sidebar__content">
        <RightSidebarContent activeTabPath={activeTabPath} />
      </div>
    </div>
  )
}

// Memoize RightSidebar to prevent unnecessary re-renders
// Only re-renders when props change
export const RightSidebar = React.memo(RightSidebarComponent)
